import type { Dayjs } from 'dayjs';
import type { Searchsummary, Summary } from 'lumen/models';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function selectMostRecentExtractDateSummary(
  summariesToSearch: (Searchsummary | Summary)[],
) {
  let mostRecentExtractDate: Dayjs | null = null;
  let mostRecentSummary = null;

  const latestSummary = summariesToSearch.find((summary) => summary.isLatest);

  // If a summary with "isLatest" present, we return that as it shouldn't get any more recent than this
  if (latestSummary) {
    return latestSummary;
  }

  summariesToSearch.forEach((summary) => {
    if (
      !mostRecentExtractDate ||
      summary.extractDate.isAfter(mostRecentExtractDate)
    ) {
      mostRecentExtractDate = summary.extractDate;
      mostRecentSummary = summary;
    }
  });

  return mostRecentSummary;
}
